// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function initError_encode(v) {
  return ["CannotInitWithEmptyCommands"];
}

function initError_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "CannotInitWithEmptyCommands") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* CannotInitWithEmptyCommands */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyInitError(initError) {
  return "CannotInitWithEmptyCommands";
}

function rewindError_encode(v) {
  if (v) {
    return [
            "CannotRewindBecauseIndexOutOfBounds",
            Decco.intToJson(v._0)
          ];
  } else {
    return ["CannotRewindBecauseMaxRetriesReached"];
  }
}

function rewindError_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CannotRewindBecauseIndexOutOfBounds" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* CannotRewindBecauseIndexOutOfBounds */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CannotRewindBecauseMaxRetriesReached" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CannotRewindBecauseMaxRetriesReached */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyRewindError(rewindError) {
  if (rewindError) {
    return "CannotRewindBecauseIndexOutOfBounds(" + (String(rewindError._0) + ")");
  } else {
    return "CannotRewindBecauseMaxRetriesReached";
  }
}

function Make(CommandModule) {
  var command_encode = function (v) {
    return Curry._1(CommandModule.command_encode, v);
  };
  var command_decode = function (v) {
    return Curry._1(CommandModule.command_decode, v);
  };
  var t_encode = function (v) {
    return Js_dict.fromArray([
                [
                  "frameId",
                  Decco.intToJson(v.frameId)
                ],
                [
                  "commands",
                  Decco.arrayToJson(command_encode, v.commands)
                ],
                [
                  "currentCommandIndex",
                  Decco.intToJson(v.currentCommandIndex)
                ],
                [
                  "commandRetriesByCommandIndex",
                  CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_encode(Decco.intToJson, v.commandRetriesByCommandIndex)
                ]
              ]);
  };
  var t_decode = function (v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
      return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */2) {
      return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var frameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
    if (frameId.TAG === /* Ok */0) {
      var commands = Decco.arrayFromJson(command_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commands"), null));
      if (commands.TAG === /* Ok */0) {
        var currentCommandIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentCommandIndex"), null));
        if (currentCommandIndex.TAG === /* Ok */0) {
          var commandRetriesByCommandIndex = CustomMap$SmartcutsMacros.MapIntWithDeccoSupport.t_decode(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandRetriesByCommandIndex"), null));
          if (commandRetriesByCommandIndex.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      frameId: frameId._0,
                      commands: commands._0,
                      currentCommandIndex: currentCommandIndex._0,
                      commandRetriesByCommandIndex: commandRetriesByCommandIndex._0
                    }
                  };
          }
          var e = commandRetriesByCommandIndex._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".commandRetriesByCommandIndex" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = currentCommandIndex._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".currentCommandIndex" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = commands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".commands" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = frameId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".frameId" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  };
  var init = function (frameId, commands) {
    if (commands.length !== 0) {
      return {
              TAG: /* Ok */0,
              _0: {
                frameId: frameId,
                commands: commands,
                currentCommandIndex: 0,
                commandRetriesByCommandIndex: undefined
              }
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: /* CannotInitWithEmptyCommands */0
            };
    }
  };
  var frameId = function (param) {
    return param.frameId;
  };
  var currentCommandIndex = function (param) {
    return param.currentCommandIndex;
  };
  var currentCommand = function (param) {
    return Belt_Array.getExn(param.commands, param.currentCommandIndex);
  };
  var remainingCommands = function (param) {
    return Belt_Array.sliceToEnd(param.commands, param.currentCommandIndex + 1 | 0);
  };
  var completedCommandsReversed = function (param) {
    return Belt_Array.reverse(Belt_Array.slice(param.commands, 0, param.currentCommandIndex));
  };
  var updateCurrentCommand = function (frame, f) {
    var currentCommandIndex = frame.currentCommandIndex;
    var commands = frame.commands;
    return {
            frameId: frame.frameId,
            commands: ArrayUtils$SmartcutsMacros.replaceAtIndex(commands, currentCommandIndex, Curry._1(f, Belt_Array.getExn(commands, currentCommandIndex))),
            currentCommandIndex: frame.currentCommandIndex,
            commandRetriesByCommandIndex: frame.commandRetriesByCommandIndex
          };
  };
  var updateRemainingCommands = function (frame, f) {
    var match = ArrayUtils$SmartcutsMacros.splitAtIndex(frame.commands, frame.currentCommandIndex + 1 | 0);
    return {
            frameId: frame.frameId,
            commands: Belt_Array.concat(match[0], Curry._1(f, match[1])),
            currentCommandIndex: frame.currentCommandIndex,
            commandRetriesByCommandIndex: frame.commandRetriesByCommandIndex
          };
  };
  var getRetriesForCommandIndex = function (param, commandIndex) {
    var arg = Belt_MapInt.get(param.commandRetriesByCommandIndex, commandIndex);
    var param$1 = 0;
    return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
  };
  var indexesOfCommandAffectedByRewinding = function (currentCommandIndex, rewindToCommandIndex) {
    return Belt_Array.slice(Belt_Array.mapWithIndex(Caml_array.make(currentCommandIndex, undefined), (function (index, param) {
                      return index;
                    })), rewindToCommandIndex, (currentCommandIndex + 1 | 0) - rewindToCommandIndex | 0);
  };
  var canRewindToCommandIndexAndRetry = function (frame, rewindToCommandIndex) {
    var currentCommandIndex = frame.currentCommandIndex;
    if (rewindToCommandIndex >= 0 && rewindToCommandIndex < currentCommandIndex) {
      return Belt_Array.every(indexesOfCommandAffectedByRewinding(currentCommandIndex, rewindToCommandIndex), (function (commandIndex) {
                    return getRetriesForCommandIndex(frame, commandIndex) <= CommandModule.maxRetries;
                  }));
    } else {
      return false;
    }
  };
  var waitForMillisBeforeRewind = function (frame) {
    return Js_math.ceil(CommandModule.baseWaitForMillis * Math.pow(2.0, getRetriesForCommandIndex(frame, frame.currentCommandIndex)));
  };
  var advance = function (param) {
    var commands = param.commands;
    var nextCommandIndex = param.currentCommandIndex + 1 | 0;
    var _nextCommand = Belt_Array.get(commands, nextCommandIndex);
    if (_nextCommand !== undefined) {
      return /* DidAdvanceCursorToNextCommand */{
              _0: {
                frameId: param.frameId,
                commands: commands,
                currentCommandIndex: nextCommandIndex,
                commandRetriesByCommandIndex: param.commandRetriesByCommandIndex
              }
            };
    } else {
      return /* CompletedAllCommandsInFrame */0;
    }
  };
  var rewindToCommandIndex = function (frame, rewindToCommandIndex$1, resetCommandState) {
    var currentCommandIndex = frame.currentCommandIndex;
    if (rewindToCommandIndex$1 >= currentCommandIndex || rewindToCommandIndex$1 < 0) {
      return {
              TAG: /* Error */1,
              _0: /* CannotRewindBecauseIndexOutOfBounds */{
                _0: rewindToCommandIndex$1
              }
            };
    }
    var commands = frame.commands;
    var commandsResetState = Belt_Array.concat(Belt_Array.concat(Belt_Array.slice(commands, 0, rewindToCommandIndex$1), Belt_Array.map(Belt_Array.slice(commands, rewindToCommandIndex$1, (currentCommandIndex + 1 | 0) - rewindToCommandIndex$1 | 0), resetCommandState)), Belt_Array.sliceToEnd(commands, currentCommandIndex + 1 | 0));
    return {
            TAG: /* Ok */0,
            _0: {
              frameId: frame.frameId,
              commands: commandsResetState,
              currentCommandIndex: rewindToCommandIndex$1,
              commandRetriesByCommandIndex: Belt_Array.reduce(indexesOfCommandAffectedByRewinding(currentCommandIndex, rewindToCommandIndex$1), frame.commandRetriesByCommandIndex, (function (commandRetriesByCommandIndex, commandIndex) {
                      return Belt_MapInt.set(commandRetriesByCommandIndex, commandIndex, getRetriesForCommandIndex(frame, commandIndex) + 1 | 0);
                    }))
            }
          };
  };
  var t_encode$1 = function (v) {
    return Decco.listToJson(command_encode, v);
  };
  var t_decode$1 = function (v) {
    return Decco.listFromJson(command_decode, v);
  };
  var completedCommandsReversed$1 = $$Array.of_list;
  var t_encode$2 = function (v) {
    return Js_dict.fromArray([
                [
                  "topFrames",
                  Decco.arrayToJson(t_encode, v.topFrames)
                ],
                [
                  "bottomFrame",
                  t_encode(v.bottomFrame)
                ]
              ]);
  };
  var t_decode$2 = function (v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
      return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */2) {
      return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var topFrames = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "topFrames"), null));
    if (topFrames.TAG === /* Ok */0) {
      var bottomFrame = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "bottomFrame"), null));
      if (bottomFrame.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  topFrames: topFrames._0,
                  bottomFrame: bottomFrame._0
                }
              };
      }
      var e = bottomFrame._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".bottomFrame" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = topFrames._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".topFrames" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  };
  var push = function (stack, content) {
    return {
            topFrames: Belt_Array.concat([content], stack.topFrames),
            bottomFrame: stack.bottomFrame
          };
  };
  var pop = function (param) {
    var bottomFrame = param.bottomFrame;
    var topFrames = param.topFrames;
    var head = Belt_Array.get(topFrames, 0);
    if (head === undefined) {
      return {
              TAG: /* ReachedBottom */0,
              _0: bottomFrame
            };
    }
    var tail = Belt_Array.sliceToEnd(topFrames, 1);
    return {
            TAG: /* PoppedStack */1,
            _0: head,
            _1: {
              topFrames: tail,
              bottomFrame: bottomFrame
            }
          };
  };
  var replaceTop = function (param, newTop) {
    var topFrames = param.topFrames;
    if (topFrames.length === 0) {
      return {
              topFrames: topFrames,
              bottomFrame: newTop
            };
    }
    var tail = Belt_Array.sliceToEnd(topFrames, 1);
    return {
            topFrames: Belt_Array.concat([newTop], tail),
            bottomFrame: param.bottomFrame
          };
  };
  var t_encode$3 = function (v) {
    return Js_dict.fromArray([
                [
                  "frames",
                  t_encode$2(v.frames)
                ],
                [
                  "history",
                  Decco.listToJson(command_encode, v.history)
                ],
                [
                  "nextFrameId",
                  Decco.intToJson(v.nextFrameId)
                ]
              ]);
  };
  var t_decode$3 = function (v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
      return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */2) {
      return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var frames = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "frames"), null));
    if (frames.TAG === /* Ok */0) {
      var history = Decco.listFromJson(command_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "history"), null));
      if (history.TAG === /* Ok */0) {
        var nextFrameId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nextFrameId"), null));
        if (nextFrameId.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    frames: frames._0,
                    history: history._0,
                    nextFrameId: nextFrameId._0
                  }
                };
        }
        var e = nextFrameId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".nextFrameId" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = history._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".history" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = frames._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".frames" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  };
  var fromInitError = function (initError) {
    return /* CannotInitWithEmptyCommands */0;
  };
  var fromRewindError = function (rewindError) {
    if (rewindError) {
      return /* CannotRewindBecauseIndexOutOfBounds */{
              _0: rewindError._0
            };
    } else {
      return /* CannotRewindBecauseMaxRetriesReached */1;
    }
  };
  var stringify = function (error) {
    if (typeof error === "number") {
      if (error !== 0) {
        return "CannotRewindBecauseMaxRetriesReached";
      } else {
        return "CannotInitWithEmptyCommands";
      }
    } else {
      return "CannotRewindBecauseIndexOutOfBounds(" + (String(error._0) + ")");
    }
  };
  var init$1 = function (commands) {
    var nextFrameId = 1;
    return Belt_Result.map(init(0, commands), (function (bottomFrame) {
                  var frames_topFrames = [];
                  var frames = {
                    topFrames: frames_topFrames,
                    bottomFrame: bottomFrame
                  };
                  var commandStack = {
                    frames: frames,
                    history: /* [] */0,
                    nextFrameId: nextFrameId
                  };
                  return /* CommandStackWithTopFrame */{
                          _0: commandStack,
                          _1: bottomFrame
                        };
                }));
  };
  var getTopFrame = function (param) {
    var param$1 = param.frames;
    var head = Belt_Array.get(param$1.topFrames, 0);
    if (head !== undefined) {
      return head;
    } else {
      return param$1.bottomFrame;
    }
  };
  var getHistory = function (param) {
    return param.history;
  };
  var maybeLastCompletedCommand = function (commandStack) {
    return Belt_Array.get(completedCommandsReversed(getTopFrame(commandStack)), 0);
  };
  var updateTopFrame = function (commandStack, f) {
    return {
            frames: replaceTop(commandStack.frames, Curry._1(f, getTopFrame(commandStack))),
            history: commandStack.history,
            nextFrameId: commandStack.nextFrameId
          };
  };
  var currentCommand$1 = function (commandStack) {
    return currentCommand(getTopFrame(commandStack));
  };
  var currentCommandIndexInTopFrame = function (commandStack) {
    return currentCommandIndex(getTopFrame(commandStack));
  };
  var updateCurrentCommand$1 = function (stack, f) {
    return updateTopFrame(stack, (function (topFrame) {
                  return updateCurrentCommand(topFrame, f);
                }));
  };
  var popTopFrame = function (stack) {
    var poppedFrame = pop(stack.frames);
    if (poppedFrame.TAG === /* ReachedBottom */0) {
      return {
              TAG: /* ReachedBottom */0,
              _0: poppedFrame._0
            };
    } else {
      return {
              TAG: /* PoppedStack */1,
              _0: poppedFrame._0,
              _1: {
                frames: poppedFrame._1,
                history: stack.history,
                nextFrameId: stack.nextFrameId
              }
            };
    }
  };
  var pushNewFrameWithCommands = function (commandStack, commands) {
    var nextFrameId = commandStack.nextFrameId;
    var frames = commandStack.frames;
    return Belt_Result.map(init(nextFrameId, commands), (function (newTopFrame) {
                  var nextStack_frames = push(frames, newTopFrame);
                  var nextStack_history = commandStack.history;
                  var nextStack_nextFrameId = nextFrameId + 1 | 0;
                  var nextStack = {
                    frames: nextStack_frames,
                    history: nextStack_history,
                    nextFrameId: nextStack_nextFrameId
                  };
                  return /* CommandStackWithTopFrame */{
                          _0: nextStack,
                          _1: newTopFrame
                        };
                }));
  };
  var onCompletedCommand = function (commandStack) {
    var topFrame = getTopFrame(commandStack);
    var completedCommand = currentCommand(topFrame);
    var withNewHistory = function (stack) {
      return {
              frames: stack.frames,
              history: Belt_List.add(stack.history, completedCommand),
              nextFrameId: stack.nextFrameId
            };
    };
    var nextTopFrame = advance(topFrame);
    if (nextTopFrame) {
      var nextTopFrame$1 = nextTopFrame._0;
      var nextCommand = currentCommand(nextTopFrame$1);
      var nextStack = withNewHistory(updateTopFrame(commandStack, (function (_topFrame) {
                  return nextTopFrame$1;
                })));
      return {
              TAG: /* MoveToNextCommandInFrame */0,
              _0: nextCommand,
              _1: nextStack
            };
    }
    var _poppedFrame = popTopFrame(commandStack);
    if (_poppedFrame.TAG === /* ReachedBottom */0) {
      return {
              TAG: /* CompletedAllCommands */2,
              _0: withNewHistory(commandStack)
            };
    }
    var nextStack$1 = withNewHistory(updateCurrentCommand$1(_poppedFrame._1, (function (currentCommand) {
                var arg = Belt_Option.map(Curry._1(CommandModule.maybeCommandThatCanPushFrame, currentCommand), CommandModule.updateCurrentCommandAfterPoppingFrame);
                return OptionUtils$SmartcutsMacros.withDefault(currentCommand, arg);
              })));
    return {
            TAG: /* PopFrameAndMoveToNextCommand */1,
            _0: currentCommand(getTopFrame(nextStack$1)),
            _1: nextStack$1
          };
  };
  return {
          command_encode: command_encode,
          command_decode: command_decode,
          Frame: {
            t_encode: t_encode,
            t_decode: t_decode,
            frameId: frameId,
            currentCommandIndex: currentCommandIndex,
            currentCommand: currentCommand,
            remainingCommands: remainingCommands,
            completedCommandsReversed: completedCommandsReversed,
            updateCurrentCommand: updateCurrentCommand,
            updateRemainingCommands: updateRemainingCommands,
            canRewindToCommandIndexAndRetry: canRewindToCommandIndexAndRetry,
            waitForMillisBeforeRewind: waitForMillisBeforeRewind,
            rewindToCommandIndex: rewindToCommandIndex
          },
          $$History: {
            t_encode: t_encode$1,
            t_decode: t_decode$1,
            completedCommandsReversed: completedCommandsReversed$1
          },
          t_encode: t_encode$3,
          t_decode: t_decode$3,
          $$Error: {
            stringify: stringify,
            fromInitError: fromInitError,
            fromRewindError: fromRewindError
          },
          init: init$1,
          getTopFrame: getTopFrame,
          getHistory: getHistory,
          maybeLastCompletedCommand: maybeLastCompletedCommand,
          currentCommand: currentCommand$1,
          currentCommandIndexInTopFrame: currentCommandIndexInTopFrame,
          updateTopFrame: updateTopFrame,
          updateCurrentCommand: updateCurrentCommand$1,
          pushNewFrameWithCommands: pushNewFrameWithCommands,
          onCompletedCommand: onCompletedCommand
        };
}

exports.initError_encode = initError_encode;
exports.initError_decode = initError_decode;
exports.stringifyInitError = stringifyInitError;
exports.rewindError_encode = rewindError_encode;
exports.rewindError_decode = rewindError_decode;
exports.stringifyRewindError = stringifyRewindError;
exports.Make = Make;
/* CustomMap-SmartcutsMacros Not a pure module */
